import { bl_fi_fixed_asset_register_depreciation_run_line_RowClass, bl_fi_fixed_asset_register_depreciation_run_line_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterDepreciationRunLineModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_depreciation_run_line: bl_fi_fixed_asset_register_depreciation_run_line_RowInterface = new bl_fi_fixed_asset_register_depreciation_run_line_RowClass();
}

